import { createSelector } from 'reselect';

export const makeIsProcessGoingOn = (expectedType) =>
  createSelector(
    (state) => state.processes.all,
    (allProcesses) => allProcesses.find(({ type }) => type === expectedType),
  );
